import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import ToolControl from "../../components/tool-control/ToolControl";

function ToolControlPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Tool Control Solutions | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title={"Tool Control Solutions"} t={t} />
      <ToolControl />
    </>
  );
}

export default ToolControlPage;
